import Refunds from "./routes/Refunds/RefundMain.vue";
import RefundsDetail from "./routes/Refunds/Detail.vue";
import Withdraw from "./routes/Withdraw/Withdraw.vue";
import WithdrawDetail from "./routes/Withdraw/Detail";
import SellerCommission from "./routes/OrderFees/SellerCommission.vue";
import FormOrderFees from "./routes/OrderFees/Form.vue";

const financeRoutes = [
  {
    path: "refunds",
    name: "Refund",
    component: Refunds,
  },
  {
    path: "refunds/:id",
    name: "Refund-Detail",
    component: RefundsDetail,
  },
  {
    path: "withdraw/:id",
    name: "Withdraw-Detail",
    component: WithdrawDetail,
  },
  {
    path: "withdraw",
    name: "Withdraw",
    component: Withdraw,
  },
  {
    path: "sellers-commission",
    name: "Sellers-Commission",
    component: SellerCommission,
  },
  {
    path: "sellers-commission/orders-fee-setting",
    name: "Orders-Fee-Setting",
    component: FormOrderFees,
  },
];

export default financeRoutes;
